export default __webpack_public_path__ + "static/media/sand5.9e44f1b7.png~";